import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getFeedKey } from '../../utils/keys';
export const DefaultFeedLimit = 10;
export const useFeed = (options) => {
    const { variables = { limit: DefaultFeedLimit }, fields = 'default', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const feedKey = getFeedKey({ variables, fields });
    return useInfiniteQuery(feedKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.posts.feed({
        after,
        ...variables,
    }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useFeed.js.map